import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Calculator } from '@ratehub/base-ui';

import PenaltyStepInputs from './PenaltyStepInputs';
import PenaltyStepSummary from './PenaltyStepSummary';


function PenaltyCalculator({
    messageBannerCopy,
    messageBannerLinkText,
    messageBannerLinkHREF,

    ...otherProps
}) {
    const [ selectedStepNumber, setSelectedStepNumber ] = useState(1);

    function handleToggleExpand(stepNumber) {
        setSelectedStepNumber(stepNumber);
    }

    function handleClickComplete(stepNumber) {
        const nextStepNumber = stepNumber + 1;
        setSelectedStepNumber(nextStepNumber);
    }

    return (
        <Calculator
            title={(
                <FormattedMessage
                    id="mtg-calculators.penaltyCalculator.calculator-title"
                    defaultMessage="Ratehub.ca’s mortgage penalty calculator"
                />
            )}
            {...otherProps}
        >
            <PenaltyStepInputs
                stepNumber={1}
                showBadge={false}
                title={(
                    <Choose>
                        <When condition={selectedStepNumber === 1}>
                            <FormattedMessage
                                id="mtg-calculators.penaltyCalculator.penaltyStepInputsTitle"
                                defaultMessage="Calculate the penalty to break your mortgage"
                            />
                        </When>
                        <Otherwise>
                            <FormattedMessage
                                id="mtg-calculators.penaltyCalculator.penaltyStepInputsTitleCompleted"
                                defaultMessage="The estimated penalty to break your mortgage"
                            />
                        </Otherwise>
                    </Choose>
                )}
                ctaText={(
                    <FormattedMessage
                        id="mtg-calculators.penaltyCalculator.penaltyStepInputsCTAText"
                        defaultMessage="Calculate my penalty"
                    />
                )}
                ctaDataName="mtg-penaltyCalculator-calculatePenalty"
                onConfirmComplete={handleClickComplete}
                isInitiallyExpanded
                onToggleExpand={handleToggleExpand}
            />

            <PenaltyStepSummary
                stepNumber={2}
                title={(
                    <FormattedMessage
                        id="mtg-calculators.penaltyCalculator.penaltyStepSummaryTitle"
                        defaultMessage="How did we calculate this?"
                    />
                )}
                messageBannerCopy={messageBannerCopy}
                messageBannerLinkText={messageBannerLinkText}
                messageBannerLinkHREF={messageBannerLinkHREF}
            />
        </Calculator>
    );
}

PenaltyCalculator.propTypes = {
    messageBannerCopy: PropTypes.string,
    messageBannerLinkText: PropTypes.string,
    messageBannerLinkHREF: PropTypes.string,
};

PenaltyCalculator.defaultProps = {
    messageBannerCopy: undefined,
    messageBannerLinkText: undefined,
    messageBannerLinkHREF: undefined,
};

export default PenaltyCalculator;
